var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMatricTable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    d: "M41 1H1V6H14.3333H27.6667H41V1Z",
    fill: "#D0D7DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "bright-stroke",
    d: "M1 1H41M1 1V41M1 1V6M41 1V41M41 1V6M41 41H1M41 41H27.6667M41 41V29.335M1 41H14.3333M1 41V29.335H14.3333M1 6H41M1 6H14.3333M41 6V17.67M41 6H27.6667M14.3333 6V17.67M14.3333 6H27.6667M14.3333 17.67V29.335M14.3333 17.67H1M14.3333 17.67H27.6667M14.3333 29.335V41M14.3333 29.335H27.6667M14.3333 41H27.6667M27.6667 6V17.67M27.6667 17.67V29.335M27.6667 17.67H41M27.6667 29.335V41M27.6667 29.335H41M41 17.67V29.335",
    stroke: "#D0D7DE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    d: "M1 41H14.3333V29.335H1V41Z",
    fill: "#D0D7DE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    d: "M14.3333 41H27.6667V29.335H14.3333V41Z",
    fill: "#D0D7DE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    d: "M27.6667 41H41V29.335H27.6667V41Z",
    fill: "#D0D7DE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    d: "M41 29.335V17.67H27.6667V29.335H41Z",
    fill: "#D0D7DE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    d: "M41 17.67V6H27.6667V17.67H41Z",
    fill: "#D0D7DE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "deep-stroke",
    d: "M41 41H1M41 41H27.6667M41 41V29.335M1 41H14.3333M1 41V29.335H14.3333M14.3333 29.335V41M14.3333 29.335H27.6667M14.3333 41H27.6667M27.6667 17.67V6H41V17.67M27.6667 17.67V29.335M27.6667 17.67H41M27.6667 29.335V41M27.6667 29.335H41M41 17.67V29.335",
    stroke: "#AFB8C1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatricTable);
export default __webpack_public_path__ + "static/media/matric-table.f41b898e3aec75b74b2de385f5d7ce57.svg";
export { ForwardRef as ReactComponent };